<template>
    <div class="parking-page">
        <div class="container">
            <div class="page-title" v-if="setup != null">
                <h1>{{ setup.page_titles.parking_title }}</h1>
            </div>
        </div>
        <parkingFilter v-if="filterCMSparams != null"></parkingFilter>
        <div class="container" v-if="filterCMSparams != null && parkingItemsArr != null && !isMobileChecker">
            <div class="items-controls">
                <parkingFindNum></parkingFindNum>
                <div class="controls">
                    <parkingShorting></parkingShorting>
                    <parkingViewBtns></parkingViewBtns>
                </div>
            </div>
        </div>
        <parkingListTable  v-if="!isMobileChecker && filterCMSparams != null && parkingItemsArr != null && parkingListView == 'list'"></parkingListTable>
        <parkingItems v-if="filterCMSparams != null && parkingItemsArr != null"></parkingItems>
        <formPage v-if="filterCMSparams != null"></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import store from '@/store.js'
    import parkingFilter from '@/components/filters/parking-filter/parking-filter.vue'
    import parkingItems from '@/components/parking-page/parking-items.vue'
    import parkingListTable from '@/components/parking-page/parking-list-table.vue'
    import parkingFindNum from '@/components/parking-page/parking-find-num.vue'
    import parkingViewBtns from '@/components/parking-page/parking-view-btns.vue'
    import parkingShorting from '@/components/filters/parking-filter/shorting-filter.vue'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'parking--page',
        components: {
            parkingFilter,
            parkingItems,
            parkingListTable,
            parkingFindNum,
            parkingViewBtns,
            parkingShorting,
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Машиноместа',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                correctWord: null,
                globalLang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            filterCMSparams: 'loadFilterCMSparams',
            parkingItemsArr: 'loadParkingItems',
            parkingListView: 'loadParkingListView',
            filterParkingDataBase: 'loadFilterParkingData',
            isOpenFilterMobile: 'loadOpenParkingMobileFilter',
            isMobileChecker: 'loadIsMobileChecker',
            // aboutPage: 'loadAboutPage',
        }),
        methods: {
            correctFindWord() {
                function pluralizeWord(number, word) {
                    const lastDigit = number % 10;
                    if (number == 1) {
                        return word + "о"; // Для чисел, заканчивающихся на 1 или 8
                    } else if (lastDigit >= 2 && lastDigit <= 4) {
                        return word + "а"; // Для чисел, заканчивающихся на 2-4
                    } else {
                        return word + ""; // Для всех остальных чисел
                    }
                }
                const word = 'машиномест';
                this.correctWord = pluralizeWord(this.filterParkingDataBase.filter_items_count, word);
            }
        },
        beforeCreate() {
            this.$store.dispatch('getParkingItems');
            document.body.dataset.page = 'parking';
        },
        created () {
            // this.correctFindWord();
        },
        mounted() {
            this.$store.watch(
                (state) => state.filterParking_Data.filter_items_count,
                (newValue) => {
                    if (newValue) {
                        this.correctFindWord();
                    }
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/parking-page/parking-page.scss';
    @import '@/styles/components/parking-page/respond/parking-page-respond.scss';
</style>